import { useFormatNumber } from '@dreamstack/i18n'
import type { FunctionComponent } from 'react'
import { BTLCalcAccordionBlock } from './BTLCalcAccordionBlock'
import {
  FIELD_PROPS,
  formatOptionsDecimal0,
  formatOptionsDecimal2,
  HorizontalLine2,
  HorizontalLine3,
  SimpleInputSmallMargin,
} from './BTLCalcUtil'

export const BTLCalcBlock1: FunctionComponent<
  React.PropsWithChildren<{
    priceValue: number
    rentValue: number
    rentalReturn: number
  }>
> = (props) => {
  const { priceValue, rentValue, rentalReturn } = props
  const formatAbsolute = useFormatNumber(formatOptionsDecimal0)
  const formatPercentage = useFormatNumber(formatOptionsDecimal2)

  return (
    <BTLCalcAccordionBlock title={'Purchase and Rent Information'}>
      <div className="pt-px-12 flex flex-row">
        <div className="flex-1">
          <SimpleInputSmallMargin
            label={'Purchase Price'}
            value={formatAbsolute(priceValue) + ' EUR'}
            inputProps={{ ...FIELD_PROPS, inputMode: 'numeric' }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
        <div className="flex-1 ml-px-20">
          <SimpleInputSmallMargin
            label={'Expected Rent'}
            value={formatAbsolute(rentValue) + ' EUR'}
            inputProps={{ ...FIELD_PROPS, inputMode: 'numeric' }}
            InputProps={{
              disableUnderline: true,
            }}
          />
        </div>
      </div>
      <div>
        <HorizontalLine2 />
        <div className="text-[16px] mt-px-20">
          Rental Return
          <br />
          <span className="text-[16px] font-semibold">
            {formatPercentage(rentalReturn) + '%'}
          </span>
        </div>
        <br />
        <HorizontalLine3 />
      </div>
    </BTLCalcAccordionBlock>
  )
}
